// src/utils/platforms.js
export const PLATFORMS = {
  facebook:  { id: 'facebook',  name: 'Facebook',               color: '#1877F2', bg: '#e8f0fe', icon: 'f'  },
  instagram: { id: 'instagram', name: 'Instagram',              color: '#E1306C', bg: '#fce8f0', icon: 'ig' },
  linkedin:  { id: 'linkedin',  name: 'LinkedIn',               color: '#0A66C2', bg: '#dbeafe', icon: 'in' },
  x:         { id: 'x',         name: 'X',                      color: '#000000', bg: '#e8e8e8', icon: 'x'  },
  pinterest: { id: 'pinterest', name: 'Pinterest',              color: '#E60023', bg: '#fee8e8', icon: 'p'  },
  gmb:       { id: 'gmb',       name: 'Google Business',        color: '#1D9E75', bg: '#d1fae5', icon: 'G'  },
  youtube:   { id: 'youtube',   name: 'YouTube',                color: '#FF0000', bg: '#fee8e8', icon: 'YT' },
  tiktok:    { id: 'tiktok',    name: 'TikTok',                 color: '#000000', bg: '#e8e8e8', icon: 'TT' },
  threads:   { id: 'threads',   name: 'Threads',                color: '#000000', bg: '#e8e8e8', icon: '@'  },
  bluesky:   { id: 'bluesky',   name: 'Bluesky',               color: '#0085ff', bg: '#e0f0ff', icon: '🦋' },
  tumblr:    { id: 'tumblr',    name: 'Tumblr',                color: '#35465c', bg: '#dde3eb', icon: 't'  },
};

export const getPlatform = (id) => PLATFORMS[id] || { id, name: id, color: '#888', bg: '#f0f0f0', icon: '?' };

export const PLATFORM_CHAR_LIMITS = {
  x: 280,
  facebook: 63206,
  instagram: 2200,
  linkedin: 3000,
  pinterest: 500,
  gmb: 1500,
  youtube: 5000,
  tiktok: 2200,
  threads: 500,
  bluesky: 300,
  tumblr: 4096,
};
